import { createSessionId } from '../../utils/createSessionId';
import { isContextChanged } from './utils/isContextChanged';
import { mapSubproduct } from './utils/mapSubproduct';
const defaultsMiddleware = context => context;
const createSessionIdMiddleware = () => {
  let previousContext;
  return context => {
    if (previousContext === undefined && context.sessionId) {
      previousContext = context;
      return context;
    }
    if (!context.sessionId || isContextChanged(previousContext, context)) {
      const newContext = {
        ...context,
        sessionId: createSessionId()
      };
      previousContext = newContext;
      return newContext;
    }
    return context;
  };
};
export const subProductMiddleware = ({
  subproduct,
  ...context
}) => ({
  ...context,
  subproduct: mapSubproduct(subproduct)
});
export const createContextMiddleware = () => {
  /**
   * Session id refers to a context session. When context changes the session will update
   */
  const sessionIdMiddleware = createSessionIdMiddleware();
  return context => defaultsMiddleware(subProductMiddleware(sessionIdMiddleware(context)));
};